module.exports = __webpack_public_path__ + "static/media/ge.16f859b5.svg";